import React__default from 'react';
import { TransitionGroupManager } from '../../../TransitionGroupManager/TransitionGroupManager.mjs';

function TransitionWrapper({
  show,
  children
}) {
  const content = show && children;
  return /*#__PURE__*/React__default.createElement(TransitionGroupManager, null, content);
}

export { TransitionWrapper };
